import { BaseWalletConnect } from './client';
import type { WalletConnectConfig } from './types';

// Registry backend the SDK reads /connect/wallets from; a dApp overrides via `apiUrl`/`registryUrl`.
const ONEDOLLAR_API_URL = 'https://onewallet-api-staging.motcaigido.xyz';

export class OneDollarConnect extends BaseWalletConnect {
  constructor(config: Omit<WalletConnectConfig, 'walletId'>) {
    super({ ...config, walletId: 'onedollar', apiUrl: config.apiUrl ?? ONEDOLLAR_API_URL });
  }
}
